module.exports = __webpack_public_path__ + "static/media/OpenSans-Regular.3ed9575d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/OpenSans/OpenSans-Regular.ttf
// module id = 306
// module chunks = 0